<template>
    <div class="wrap">
        <h1>회원가입</h1>
        <div class="signup">
            <h2>2단계. 약국(사업자등록증) 등록</h2>
            <div class="signup-upload-box">
                <label for="signup-upload">
                    <p>여기를 클릭해서 이미지 파일을 선택해주세요<br />(JPG 파일 등록가능)</p>
                    <input type="file" name="signup-upload" id="signup-upload" @change="filesChange">
                    <img :src="preview_src" alt="" title="" style="width: 100%; height: 100%; position: absolute; top: 0; left: 0;">
                </label>
            </div>
            <div class="signup-next-btn">
                <button type="button" @click="onNext">가입하기</button>
            </div>
        </div>
    </div>
    
</template>

<script>
    import { UPLOAD_TYPE } from '@/lib/constants'
    import Upload from '@/lib/upload'
  export default {
    name: 'step2',
    data () {
      return {
        preview_src: null,
        upload_obj: null
      }
    },
    methods: {
      onNext () {
        if (this.upload_obj) {
          this.$emit('onNext', this.upload_obj)
        } else {
          alert('사진이 선택되지 않았습니다!')
        }
      },
      filesChange (event) {
        let file_kind = event.target.name;
        let upload_files = event.target.files;

        const reader = new FileReader();

        reader.onload = (e) => {
          this.preview_src = e.target.result;
        }
        reader.readAsDataURL(upload_files[0])

        this.upload_obj = new Upload(UPLOAD_TYPE.PHARM_LIC_IMG, {key_id: 'key', resize_width: 800})

        for (let file of upload_files) {
          // formData.append(file_kind, file)
          this.upload_obj.append(file)
        }
        // this.is_chosen_license = true
      }
    }
  }
</script>

<style scoped>
    .wrap {
        width: 100%;
        height: 100%;
        padding: 30px 0;
        background-color: #f5f6fa;
    }

    .wrap h1 {
        color: #474747;
        text-align: center;
        letter-spacing: -.5px;
        font: 400 32px 'Noto Sans KR', sans-serif;
    }

    .signup {
        width: 100%;
        max-width: 700px;
        padding: 30px;
        position: relative;
        background-color: #fff;
        border: 1px solid #eee;
        box-sizing: border-box;
        margin: 30px auto 30px;
    }

    .signup h2 {
        margin-bottom: 20px;
        font: 400 20px 'Noto Sans KR', sans-serif;
    }

    .signup-upload-box {
        width: 100%;
        height: 600px;
        text-align: center;
        position: relative;
        border: 2px dotted #d8d8d8;
    }

    .signup-upload-box label {
        display: block;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: relative;
        background-color: #fafafc;
    }

    .signup-upload-box label p {
        color: #acacae;
        width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        font: 400 16px/34px 'Noto Sans KR', sans-serif;
    }

    .signup-upload-box input {
        outline: 0;
        display: none;
    }

    .signup-next-btn {
        color: #fff;
        width: 150px;
        height: 50px;
        margin: 30px auto 0;
        background-color: #746ce6;
    }

    .signup-next-btn button {
        color: #fff;
        width: 100%;
        height: 100%;
        border: none;
        outline: 0;
        cursor: pointer;
        text-align: center;
        background-color: transparent;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
    }

</style>